<template>
  <div class="body"
       v-if="data != null">
    <div class="guanggao"
         v-if="data.backImageH5 || data.backImagePC">
      <img v-show="isMobile()"
           :src="data.backImageH5"
           alt="">
      <img v-show="!isMobile()"
           :src="data.backImagePC"
           alt="">
    </div>
    <div class="box">
      <div class="top">
        <p class="title">{{ data.name }}</p>
        <p class="abstract">{{ data.abstract }}</p>
      </div>
      <div class="mid">
        <div class="qbox"
             v-for="(item, index) in queList"
             :key="index">
          <div class="qtitle">
            <i v-show="item.isRequired"
               style="color:red;">* </i>
            <span>{{ item.question }}</span>
          </div>
          <div v-if="ansList.length > 0">
            <div v-if="item.questionType == 1">
              <el-radio-group v-model="ansList[index].ans">
                <el-radio v-for="(items, indexs) in item.answerList"
                          :label="items.id"
                          :key="indexs">{{ items.answer }}
                </el-radio>
              </el-radio-group>
            </div>
            <div v-if="item.questionType == 2">
              <el-checkbox-group v-model="ansList[index].ans">
                <el-checkbox v-for="(items, indexs) in item.answerList"
                             :label="items.id"
                             :key="indexs">{{ items.answer
                }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-if="item.questionType == 3">
              <el-input v-model="ansList[index].ans"
                        :placeholder="'请输入' + item.question"></el-input>
            </div>
            <div v-if="item.questionType == 4">
              <el-input type="textarea"
                        :rows="3"
                        :placeholder="'请输入' + item.question"
                        resize="none"
                        v-model="ansList[index].ans">
              </el-input>
            </div>
            <div v-if="item.questionType == 5">
              <el-date-picker v-model="ansList[index].ans"
                              style="width:100%"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </div>
            <div v-if="item.questionType == 6">
              <el-cascader v-model="ansList[index].ans"
                           style="width:100%"
                           ref="areacasc"
                           :options="arealist">
              </el-cascader>
            </div>
            <div v-if="item.questionType == 7">
              <el-input :placeholder="'请输入' + item.question"
                        v-model="ansList[index].ans">
                <template slot="append"
                          v-if="item.answerList.length > 0">{{ item.answerList[0].unit }}</template>
              </el-input>
            </div>
            <div v-if="item.questionType == 8">
              <el-input v-model="ansList[index].ans"
                        placeholder="请输入11位手机号"></el-input>
            </div>
            <div v-if="item.questionType == 9">
              <div class="upload">
                <webupload :fileaccept="item.answerList[0].fileSuffix == 1 ? 'image/png,image/gif,image/jpg,image/jpeg' : ''"
                           :index="index"
                           :isUpload="isUpload"
                           :Maxfileszie="Number(item.answerList[0].unit)"
                           :onSuccess="handleSuccess">
                  <div class="uploadBox">
                    <img src="../../assets/img/import.png"
                         alt="">
                    <span>上传资源</span>
                  </div>
                </webupload>
                <div class="tip">注：最多可上传{{ item.answerList[0].number }}个最大为{{ item.answerList[0].unit }}MB的文件</div>
              </div>
              <div class="uploadBot">
                <div class="upAnsBox"
                     v-for="(items, indexs) in ansList[index].ans"
                     :key="indexs">
                  <div class="upaImg"
                       v-show="item.answerList[0].fileSuffix == 1">
                    <el-image style="width: 70px; height: 70px"
                              :src="items.url"
                              fit="contain"></el-image>
                    <div class="updel"
                         @click="toDelUp(index, indexs)">
                      <img src="../../assets/img/del.png"
                           alt="">
                    </div>
                  </div>
                  <div class="upaMore"
                       v-show="item.answerList[0].fileSuffix != 1">
                    <img src="../../assets/img/res.png"
                         style="width: 25px;height: 25px;margin: 8px 0 2px;"
                         alt="">
                    <span v-if="items.name.length >= 7">...{{ items.name.substr(items.name.length - 6, 6) }}</span>
                    <span v-if="items.name.length < 7">{{ items.name }}</span>
                    <div class="updel"
                         @click="toDelUp(index, indexs)">
                      <img src="../../assets/img/del.png"
                           alt="">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div v-show="qid == 32 ||qid == 46 ||qid == 48 ||qid == 50 " class="">
        <p style=" margin-left: 10px;font-size: 14px;">知情同意书<span style="color:red">*</span></p>
        <el-checkbox v-model="zqschecked" border size="mini" style="border: 0 !important;">我已阅读并接受</el-checkbox>
        <div class="clause" @click="zqsvisible = !zqsvisible">
          <span style="font-size: 12px;" :style="{ 'color': zqschecked == true ? '#666666' : '#66b1ff' }">知情同意书 </span>

        </div>
        <div class="dialog_div">
          <el-dialog :visible.sync="zqsvisible" style="line-height:30px ;">

            <p style="text-align: justify;text-indent: 20px;"><span style="color: rgb(102, 102, 102);">
                阿斯利康投资中国有限公司（以下简称AZ）（作为本知情并同意书项下的个人信息处理者）尊重并保护用户个人信息。在您使用AZ提供的安全防护产品及服务（包含但不限于您参与的线上及线下所有安全防护相关活动和服务），
                AZ请您完整地阅读</span><span style="color: black;">AZ隐私政策</span><span
                style="color: rgb(102, 102, 102);">（包括中国子公司附录）并确认如下知情并同意书。</span></p>
            <p style="text-align: justify;text-indent: 20px;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp;
                &nbsp; </span><u><strong>个人信息的收集和使用：</strong></u></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp;
                本次直播的主要目的为：为HCP提供会议直播服务，AZ需要在您注册、登录和/或使用产品/服务和/或参与本次活动时收集您以下个人信息：</span></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);">· 姓名 ·单位 ·科室 ·电话 </span></p>
            <p style="text-align: justify;text-indent: 20px;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp;
                &nbsp;
              </span><u><strong>您同意我们为实现主要处理目的收集、使用以上个人信息（包括敏感个人信息）。如果您选择不提供或不同意我们收集、使用以上部分或全部信息，将导致本产品（或服务）无法完全正常运行，我们将无法为您服务，或您将无法继续参与本次活动。</strong></u>
            </p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp; 收集这些信息的主要目的为：
                ·验证您的身份是医生，AZ还需要在您注册、登录和/或使用产品/服务和/或参与本次活动时收集您以下个人信息：</span></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);">· 姓名 ·工作单位、办公地址 ·科室·电话</span></p>
            <p style="text-align: justify;text-indent: 20px;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp;
                &nbsp;
              </span><u><strong>您同意我们为实现次要处理目的收集、使用以上个人信息（包括敏感个人信息）。如果您选择不提供或不同意我们收集、使用以上部分或全部信息，您将无法正常使用相关附加业务功能或无法达到我们拟达到的功能效果/活动次要目的，但这不会影响您使用核心业务功能或实现活动主要目的。</strong></u>
            </p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp;
                在任何情况下，我们将以对个人权益影响最小的方式处理您的上述个人信息（包括敏感个人信息）。</span></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp;
                AZ将直接收集或是从AZ的合作方（包括但不限于AZ的经销商、服务方或其它网络平台）处依法收集您的个人信息。AZ和AZ的合作方将在必要和合理的范围内向您收集个人信息。请您真实、准确地提供个人信息。</span>
            </p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp;
                在遵守国家法律法规和</span><span style="color: black;">AZ隐私政策</span><span
                style="color: rgb(102, 102, 102);">的前提下，AZ将通过合同形式与该第三方共同确定应满足的个人信息安全要求，以及在个人信息安全方面各自应承担的责任和义务。</span>
            </p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp; </span></p>
            <p style="text-align: justify;text-indent: 20px;"><strong> &nbsp; &nbsp;
                &nbsp;</strong><u><strong>个人信息的保密和披露：</strong></u></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp;
                &nbsp;AZ遵照法律法规对个人信息承担保密的义务，惟当法律法规确有要求或者政府机关提出明确指令的情况下，AZ将适当披露个人信息。</span></p>
            <p style="text-align: justify;text-indent: 20px;"><span style="color: rgb(102, 102, 102);"><strong> &nbsp;
                  &nbsp; </strong></span><span style="color: rgb(102, 102, 102);"><u><strong>
                  </strong></u></span><u><strong>个人信息的存储：</strong></u></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp;
                &nbsp;收集的个人信息将保存在腾讯会议的服务器上，时间为1个月</span></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp; </span></p>
            <p style="text-align: justify;text-indent: 20px;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp;
                &nbsp;</span><u><strong>个人信息的管理和保护：</strong></u></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp;
                &nbsp;反对权：您可以限制或者拒绝AZ对您的个人信息的处理。您的限制或者拒绝可能导致本产品（或服务）无法完全正常运行，我们可能无法为您提供与您限制或拒绝处理的个人相关的服务，或您可能无法参与或继续参与本次活动的全部或相关环节。</span>
            </p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp;
                &nbsp;查阅和知情权：您可以要求AZ确认您的个人信息是否得到处理。您还有权要求查阅您的个人信息和了解以下信息：处理的目的；处理的个人信息类别；已经获得个人信息的第三方身份或类型等。</span></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp;
                &nbsp;更正权：如果您的个人信息不正确，您有权让AZ更正您的个人信息。考虑到处理的目的，您还有权将有关您的不完整个人信息予以完整，包括提供补充信息。</span></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp;
                &nbsp;删除权：在下列情况下，AZ
                会主动删除您的个人信息，您也可以要求AZ删除您的个人信息：（i）处理目的已实现、无法实现或为实现处理目的不再必要；（ii）AZ停止提供产品或者服务，AZ取消本次活动或者本次活动已全部完成，或者保存期限已届满；（iii）您撤回同意；（iv）AZ违反法律法规规定，收集、使用、共享、转让、披露个人信息的；（v）AZ违反</span><span
                style="color: black;">AZ隐私政策</span><span
                style="color: rgb(102, 102, 102);">及本知情并同意书的内容，收集、使用、共享、转让、披露个人信息的；以及（vi）法律法规规定的其他情形。但是，法律法规规定的保存期限未届满，或者</span>
            </p>
            <p style="text-align: justify;text-indent: 20px;"><span style="color: rgb(102, 102, 102);"><strong> &nbsp;
                  &nbsp; </strong></span><span
                style="color: rgb(102, 102, 102);"><u><strong>AZ</strong></u></span><u><strong>隐私政策：</strong></u></p>
            <p style="text-align: justify;"><span style="color: rgb(102, 102, 102);"> &nbsp; &nbsp; &nbsp;
                &nbsp;关于个人信息的更多处理规则，请完整阅读</span><span style="color: black;">AZ隐私政策</span><span
                style="color: rgb(102, 102, 102);">以了解更详细的情况。您知晓并同意，AZ将不时地修改更新</span><span
                style="color: black;">AZ隐私政策</span><span
                style="color: rgb(102, 102, 102);">。您可以在AZ官网查阅最新的AZ隐私政策。您持续使用AZ的产品（或服务）或参与活动即表示您同意经修订更新的</span><span
                style="color: black;">AZ隐私政策</span><span style="color: rgb(102, 102, 102);">。</span></p>
            <p> </p>

          </el-dialog>
        </div>
        <div>
          <p style=" margin-left: 10px;font-size: 14px;"> 自我声明复选框<span style="color:red;font-size: 12px;">*</span></p>
          <el-checkbox v-model="checked" border size="mini" style="border: 0 !important;">以上信息为本人真实登录填写</el-checkbox>
        </div>
      </div> -->

      <!-- <div v-show="qid == 35 || qid == 37 || qid == 38" class="">
        <p style=" margin-left: 10px;font-size: 14px;">隐私条款<span style="color:red">*</span></p>
        <el-checkbox v-model="fltchecked" border size="mini" style="border: 0 !important;">我已阅读并接受</el-checkbox>
        <div class="clause" @click="fltvisible = !fltvisible">
          <span style="font-size: 12px;" :style="{ 'color': fltchecked == true ? '#666666' : '#66b1ff' }">隐私条款 </span>
        </div>
        <div class="dialog_div">
          <el-dialog :visible.sync="fltvisible" style="line-height:30px ;">
            <p>
              海峡两岸医药卫生交流协会全科医学分会学术平台高度重视用户的隐私和个人信息保护，制定了相应的内部安全管理制度和操作规程，并对网络安全负责人进行严格的背景和资历审查，切实落实网络安全保护责任。海峡两岸医药卫生交流协会全科医学分会学术平台会采取适当的安全措施和技术措施，确保所收集的个人信息安全，防止信息泄露、毁损、丢失。根据海峡两岸医药卫生交流协会全科医学分会学术平台的内部安全管理制度，一旦发生或可能发生您的个人信息泄露、毁损、丢失的情况时，海峡两岸医药卫生交流协会全科医学分会学术平台会列为重大安全事件，一经发现会立即采取补救措施，根据法律的有关规定，及时告知相关用户并向有关部门报告。
              如有问题，可联系客服：电话：010-83116133，（周一~周五 09：00~17：00）。——海峡两岸医药卫生交流协会全科医学分会学术平台</p>
          </el-dialog>
        </div>
        <div>
          <p style=" margin-left: 10px;font-size: 14px;"> 自我声明复选框<span style="color:red;font-size: 12px;">*</span></p>
          <el-checkbox v-model="zwsmchecked" border size="mini" style="border: 0 !important;">以上信息为本人真实登录填写
          </el-checkbox>
        </div>
      </div> -->
      <div v-show="isOpenPrivacyPolicy"
           class="">
        <el-checkbox v-model="checked"
                     border
                     size="mini"></el-checkbox>
        <div class="clause"
             @click="visible = !visible"
             :style="{ 'color': checked == true ? '#666666' : '#66b1ff' }">
          {{privacyPolicyName}}</div>
        <el-dialog :visible.sync="visible">
          <div v-html="privacyPolicy"></div>
        </el-dialog>
      </div>

           <!-- 新增隐私条款 -->
           <div class="">
        <el-checkbox v-model="yszcchecked" border size="mini"></el-checkbox>
        <div class="clause" @click="yszcvisible = !yszcvisible" :style="{ 'color': yszcchecked == true ? '#666666' : '#66b1ff' }">
          隐私政策</div>
        <el-dialog style="height:100%;" :visible.sync="yszcvisible">
          <div style="height:700px;min-height:500px;overflow-y:auto">
            <div v-html="PrivacyPolicyexplain1"></div>
          </div>
        </el-dialog>
      </div>
      <div class="bot">
        <el-button type="primary"
                   @click="setQuestion()"
                   style="width:200px">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { areaList } from '@vant/area-data';
import webupload from '../../components/queUpload'
export default {
  components: {
    webupload
  },
  data () {
    return {
      AuthorId: 0,
      data: null,
      ansList: [],
      qid: 0,
      callback: '',
      userType: 0,
      arealist: [],
      queList: [],
      isUpload: [],
      zqsvisible: false,
      visible: false,
      zqschecked: false,//条款
      checked: false,  //个人信息
      isOpenPrivacyPolicy: false, //是否有条款
      privacyPolicy: '', //条款说明文字
      privacyPolicyName: '',
      fltchecked: false,
      fltvisible: false,
      zwsmchecked: false,
      iswechatuserid: false,
      expireType: 1,
      yszcchecked: false,
      yszcvisible: false,
      PrivacyPolicyexplain1: ''
    }
  },
  created () {
    this.getArea();
    this.GetNewInfoById();
    if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
      'qid')) {
      this.qid = this.$route.query.qid
    }
    if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
      'callback')) {
      this.callback = this.$route.query.callback;
    }
    if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
      'ulogintype')) {
      let ulogintype = Number(this.$route.query.ulogintype);
      if (ulogintype == 1) {
        let info = this.$cookies.get('meetingkey')
        if (info) {
          if (info.type == 1) {
            this.AuthorId = Number(info.userid)
          } else if (info.type == 2) {
            this.iswechatuserid = true;
            this.AuthorId = Number(info.userid);
          }
          this.getQuestion()
        } else {
          if (this.callback != '') {
            window.location.href = decodeURIComponent(this.callback);
          } else {
            this.tologin();
          }
        }
      } else if (ulogintype == 2) {
        if (this.$cookies.isKey('token_chinagp')) {
          var _tokenkey = this.$cookies.get('token_chinagp');
          this.httphelper
            .post('/api/LoginApi/CheckToken', {
              tokenKey: _tokenkey
            })
            .then(res => {
              if (res.data.code == 200) {
                this.AuthorId = res.data.data.id;
                this.getQuestion()
              } else {
                if (this.callback != '') {
                  window.location.href = decodeURIComponent(this.callback);
                } else {
                  this.tologin();
                }
              }
            });
        } else {
          if (this.callback != '') {
            window.location.href = decodeURIComponent(this.callback);
          } else {
            this.tologin();
          }
        }
      }
    } else {
      if (localStorage.getItem('ResData')) {
        this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
        this.getQuestion()
      } else if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
        'tokenkey')) {
        this.httphelper
          .post('/api/LoginApi/CheckToken', {
            tokenKey: this.$route.query.tokenkey
          })
          .then(res => {
            if (res.data.code == 200) {
              localStorage.setItem('ResData', JSON.stringify(res.data.data));
              var aData = new Date();
              var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
              var VipEdDate = res.data.data.memberDate.m_EndDate;
              var CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
              var VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
              if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
                this.userType = 0;
              } else {
                if (res.data.data.memberDate.m_Type == 1) {
                  this.userType = 1;
                } else if (res.data.data.memberDate.m_Type == 2) {
                  this.userType = 2;
                } else {
                  this.userType = 0;
                }
              }
              localStorage.setItem('userType', this.userType);
              this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id
              if (Object.keys(this.$route.query).length > 0 && Object.prototype.hasOwnProperty.call(this.$route.query,
                'qid')) {
                this.qid = this.$route.query.qid
                this.getQuestion()
              }
            } else {
              let callback = encodeURIComponent(window.location.href);
              window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
            }
          });
      } else {
        this.tologin();
      }
    }
  },
  methods: {
    tologin () {
      let callback = encodeURIComponent(window.location.href);
      if (this.isMobile()) {
        Dialog.alert({
          title: '提示',
          message: '请先登录',
        })
          .then(() => {
            window.location.href = this.httphelper.IsDebugH5GP519() + '/pages/login/login?callback=' + callback;
          })
      } else {
        this.$alert('请先登录', '提示', {
          confirmButtonText: '确定',
          showClose: false,
          callback: action => {
            if (action == 'confirm') {
              this.$router.push({
                path: '/loginIndex/login',
                query: {
                  callback: callback
                }
              })
            }
          }
        });
      }
    },
    /** 获取省市区 */
    getArea () {
      for (let a in areaList.province_list) {
        this.arealist.push({
          value: a,
          label: areaList.province_list[a],
          children: []
        });
        for (let b in areaList.city_list) {
          if (b.substring(0, 2) == a.substring(0, 2)) {
            this.arealist[this.arealist.length - 1].children.push({
              value: b,
              label: areaList.city_list[b],
              children: []
            });
            for (let c in areaList.county_list) {
              if (c.substring(0, 4) == b.substring(0, 4)) {
                this.arealist[this.arealist.length - 1].children[this.arealist[this.arealist.length - 1].children.length - 1].children.push({
                  value: c,
                  label: areaList.county_list[c]
                });
              }
            }
          }
        }
      }
    },
    handleSuccess (response) {
      this.ansList[response.index].ans.push({
        id: response.resid,
        url: response.ossfileurl,
        name: response.ossfilename
      })
      if (this.ansList[response.index].ans.length == this.queList[response.index].answerList[0].number) {
        this.isUpload.push(response.index)
      }
    },
    /** 获取问卷问题 */
    getQuestion () {
      this.httphelper.get('/api/QuestionnaireApi/GetMeetingQualityInfo', {
        qId: this.qid
      }).then((res) => {
        if (res.code == 200) {
          this.data = res.data;
          this.expireType = res.data.expireType
          this.getIsQuestion();

          if (this.data.isOpenPrivacyPolicy == true) {
            this.isOpenPrivacyPolicy = res.data.isOpenPrivacyPolicy
            this.privacyPolicy = res.data.privacyPolicy
            this.privacyPolicyName = res.data.privacyPolicyName
          }
          this.$h5weixinshare.WeiXinShare(res.data.name, window.location.href, res.data.abstract, res.data.logoUrl);
          this.queList = res.data.questionList
          for (let i = 0; i < this.queList.length; i++) {
            if (this.queList[i].questionType == 2 || this.queList[i].questionType == 9) {
              this.ansList.push({
                id: this.queList[i].id,
                aid: 0,
                type: this.queList[i].questionType,
                isr: this.queList[i].isRequired,
                ans: []
              })
            } else {
              this.ansList.push({
                id: this.queList[i].id,
                aid: 0,
                type: this.queList[i].questionType,
                isr: this.queList[i].isRequired,
                ans: ''
              })
            }
          }
        }
      })
    },
    /** 是否填写过 */
    getIsQuestion () {
      this.httphelper.get('/api/QuestionnaireApi/CheckIsFeedbackList', {
        qid: this.qid,
        userid: this.AuthorId,
        expiretype: this.expireType
      }).then((res) => {
        if (res.code == 200) {
          if (this.data.liveId > 0) {
            if (this.data.liveType == 1) {
              this.$router.push({
                path: '/muduLive?',
                query: {
                  id: this.data.liveId,
                  mid: this.data.metid
                }
              })
            } else if (this.data.liveType == 2) {
              this.$router.push({
                path: '/huodeLive?',
                query: {
                  id: this.data.liveId,
                  mid: this.data.metid
                }
              })
            }
          } else {
            this.$router.push({
              name: 'questionSuccess',
              query: {
                qid: this.qid
              }
            })
          }

        }
      })
    },
    p (s) {
      return s < 10 ? '0' + s : s
    },
    toDelUp (fIndex, sIndex) {
      this.ansList[fIndex].ans.splice(sIndex, 1)
      for (let i = 0; i < this.isUpload.length; i++) {
        if (this.isUpload[i] == fIndex) this.isUpload.splice(i, 1)
      }
    },
    /** 提交问卷 */
    setQuestion () {
      let time = this.getTime()
      let alist = []
      for (let i = 0; i < this.ansList.length; i++) {
        if (this.ansList[i].ans.length == 0 && this.ansList[i].isr) {
          return this.toWarnTip('有必填内容未填写')
        }

        if (this.ansList[i].type == 1) {
          alist.push({
            userId: this.AuthorId,
            id: this.ansList[i].aid,
            questinoID: this.ansList[i].id,
            answerID: Number(this.ansList[i].ans),
            answerContent: '',
            addtime: time
          })
        } else if (this.ansList[i].type == 2) {
          for (let j = 0; j < this.ansList[i].ans.length; j++) {
            alist.push({
              userId: this.AuthorId,
              id: this.ansList[i].aid,
              questinoID: this.ansList[i].id,
              answerID: Number(this.ansList[i].ans[j]),
              answerContent: '',
              addtime: time
            })
          }
        } else if (this.ansList[i].type == 5) {
          let dataStr = ''
          if (this.ansList[i].ans != '') {
            const d = new Date(this.ansList[i].ans)
            dataStr = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate())
          }
          alist.push({
            userId: this.AuthorId,
            id: this.ansList[i].aid,
            questinoID: this.ansList[i].id,
            answerID: 0,
            answerContent: dataStr,
            addtime: time
          })
        } else if (this.ansList[i].type == 6) {
          let str = ''
          let val = this.$refs['areacasc'][0].inputValue
          if (val != null) str = val.replace(/ /g, '').split('/').join(',')
          alist.push({
            userId: this.AuthorId,
            id: this.ansList[i].aid,
            questinoID: this.ansList[i].id,
            answerID: 0,
            answerContent: str,
            addtime: time
          })
        } else if (this.ansList[i].type == 7) {
          alist.push({
            userId: this.AuthorId,
            id: this.ansList[i].aid,
            questinoID: this.ansList[i].id,
            answerID: 0,
            answerContent: this.ansList[i].ans + this.queList[i].answerList[0].unit,
            addtime: time
          })
        } else if (this.ansList[i].type == 8) {
          let mobile = this.ansList[i].ans
          var reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
          if (!reg.test(mobile) && (this.ansList[i].isr || !this.ansList[i].isr && mobile != '')) {
            return this.toWarnTip('手机号格式错误')
          }
          alist.push({
            userId: this.AuthorId,
            id: this.ansList[i].aid,
            questinoID: this.ansList[i].id,
            answerID: 0,
            answerContent: mobile,
            addtime: time
          })
        } else if (this.ansList[i].type == 9) {
          let residStr = []
          for (let j = 0; j < this.ansList[i].ans.length; j++) {
            residStr.push(this.ansList[i].ans[j].id)
          }
          alist.push({
            userId: this.AuthorId,
            id: this.ansList[i].aid,
            questinoID: this.ansList[i].id,
            answerID: 0,
            answerContent: residStr.join(','),
            addtime: time
          })
        } else {
          if (this.queList[i].question == "执医执照编号" && this.ansList[i].ans.length >= 16) {
            return this.toWarnTip('执医执照编号有误不能超过15位')
          }
          alist.push({
            userId: this.AuthorId,
            id: this.ansList[i].aid,
            questinoID: this.ansList[i].id,
            answerID: 0,
            answerContent: this.ansList[i].ans,
            addtime: time
          })
        }
      }
      // if (this.data.id == 32 || this.data.id == 46 || this.data.id == 48 || this.data.id == 50) {
      //   if (this.zqschecked == false) {
      //     this.$message({
      //       type: 'warning',
      //       message: '请先阅读并同意《知情同意书》'
      //     });
      //     return
      //   }
      //   if (this.checked == false) {
      //     this.$message({
      //       type: 'warning',
      //       message: '请勾选自我声明复选框'
      //     });
      //     return
      //   }
      // } else if (this.data.id == 35 || this.data.id == 37 || this.data.id == 38) {
      //   if (this.fltchecked == false) {
      //     this.$message({
      //       type: 'warning',
      //       message: '请先阅读并同意《隐私条款》'
      //     });
      //     return
      //   }
      //   if (this.zwsmchecked == false) {
      //     this.$message({
      //       type: 'warning',
      //       message: '请勾选自我声明复选框'
      //     });
      //     return
      //   }
      // }
      if (this.isOpenPrivacyPolicy && this.checked == false) {
        this.$message({
          type: 'warning',
          message: '请先阅读并同意' + this.privacyPolicyName
        });
        return
      }
      if (this.yszcchecked == false) {
        this.$message({
          type: 'warning',
          message: '请先阅读并同意隐私政策'
        });
        return
      }
      this.httphelper.post('/api/QuestionnaireApi/SumbitFeedback', {
        userId: this.AuthorId,
        qid: this.data.id,
        resultIDs: '',
        addtime: time,
        feedbackResultList: alist,
        iswechatuserid: this.iswechatuserid
      }).then((res) => {
        if (res.data.code == 200) {
          if (this.callback != '') {
            window.location.href = decodeURIComponent(this.callback);
          } else {
            this.$router.push({
              name: 'questionSuccess',
              query: {
                qid: this.qid
              }
            })
          }

        } else {
          this.toWarnTip('提交失败')
        }
      })
    },
    toWarnTip (tip) {
      if (this.isMobile()) Toast.fail(tip);
      else this.$message.warning(tip);

    },
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    },
    getTime () {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();
      var Seconds = date.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return year + '-' + month + '-' + day + ' ' + Hours + ':' + Minutes + ':' + Seconds;
    },
     /**隐私政策 */
     GetNewInfoById() {
      let _this = this;
      _this.httphelper
        .get('/api/NewApi/GetGPSiteNewInfoById', {
          Id: parseInt(758)
        })
        .then(res => {
          if (res.code == 200) { 
            _this.PrivacyPolicyexplain1 = res.data.contents
                .replace(/white-space:nowrap/g, 'white-space:pre-wrap')
                .replace(/<video /g, "<video @contextmenu.prevent='' ")
                .replace(/<audio /g, "<audio @contextmenu.prevent='' ");
          }
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.clause {
    display: inline-block;
    cursor: pointer;
}

::v-deep .el-dialog {
    width: 70%;
}

@media screen and (min-width: 1024px) {
    .body {
        min-height: 100%;
        width: 100%;
        background-color: #e5f2ff;
    }

    .guanggao {
        height: 300px;
        width: 100%;
        display: flex;
        justify-content: center;
        overflow: hidden;
        min-width: 1240px;
        position: relative;

        img {
            height: 300px;
            width: 1920px;
            max-width: 1920px;
            position: absolute;
        }
    }

    .box {
        width: 1240px;
        margin: 0 auto;
        min-height: 100vh;
        // background-color: #eee;
        background-size: 100% 100%;
        padding: 70px 60px;
        box-sizing: border-box;

        .top {
            padding: 20px;
            background-color: #fff;
            border-radius: 10px;

            .title {
                line-height: 30px;
                font-size: 22px;
                font-weight: 800;
                text-align: center;
                margin-bottom: 10px;
            }

            .abstract {
                font-size: 14px;
                color: rgb(80, 80, 80);
            }
        }

        .mid {
            margin: 20px 0;

            .qbox {
                padding: 20px;
                background-color: #fff;
                border-radius: 10px;
                margin-bottom: 10px;

                .qtitle {
                    margin-bottom: 20px;
                }

                .upload {
                    display: flex;
                    align-items: flex-end;

                    .uploadBox {
                        width: 113px;
                        height: 40px;
                        border-radius: 4px;
                        border: 1px solid #dcdfe6;
                        box-sizing: border-box;
                        background: #ffffff;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        font-size: 14px;
                        line-height: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #666666;
                        padding: 0 13px;
                        cursor: pointer;
                    }

                    .tip {
                        font-size: 12px;
                        color: #666666;
                        margin-left: 10px;
                        margin-bottom: 3px;
                    }
                }

                .uploadBot {
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 15px;

                    .upAnsBox {
                        width: 70px;
                        height: 70px;
                        margin-right: 10px;
                        border-radius: 4px;
                        border: 1px solid #dcdfe6;
                        overflow: hidden;
                        position: relative;

                        .upaMore {
                            width: 70px;
                            height: 70px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            font-size: 12px;
                        }

                        .updel {
                            position: absolute;
                            top: 0px;
                            right: -40px;
                            width: 100px;
                            height: 20px;
                            transform: rotate(40deg);
                            background-color: red;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;

                            img {
                                width: 12px;
                                height: 12px;
                            }
                        }
                    }
                }
            }
        }

        .bot {
            margin-top: 50px;
            display: flex;
            justify-content: center;
        }
    }
}

@media screen and (max-width: 1024px) {
    .body {
        min-height: 100%;
        background-color: #e5f2ff;
    }

    .guanggao {
        height: 200px;
        width: 100%;

        img {
            height: 200px;
            width: 100%;
        }
    }

    .box {
        min-height: 100vh;
        // background-color: #eee;
        background-size: 100% 100%;
        padding: 50px 10px;
        box-sizing: border-box;

        .top {
            padding: 10px 15px 15px;
            background-color: #fff;
            border-radius: 10px;

            .title {
                line-height: 30px;
                font-size: 18px;
                font-weight: 800;
                text-align: center;
                margin-bottom: 10px;
            }

            .abstract {
                font-size: 12px;
                color: rgb(80, 80, 80);
            }
        }

        .mid {
            margin: 20px 0;

            .qbox {
                padding: 10px 15px 15px;
                background-color: #fff;
                border-radius: 10px;
                margin-bottom: 10px;

                .qtitle {
                    margin-bottom: 10px;
                    font-size: 14px;
                }

                .upload {
                    display: flex;
                    align-items: flex-end;

                    .uploadBox {
                        width: 113px;
                        height: 40px;
                        border-radius: 4px;
                        border: 1px solid #dcdfe6;
                        box-sizing: border-box;
                        background: #ffffff;
                        display: flex;
                        align-items: center;
                        justify-content: space-around;
                        font-size: 14px;
                        line-height: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #666666;
                        padding: 0 13px;
                        cursor: pointer;
                    }

                    .tip {
                        font-size: 12px;
                        color: #666666;
                        margin-left: 10px;
                        margin-bottom: 3px;
                    }
                }

                .uploadBot {
                    display: flex;
                    flex-wrap: wrap;
                    margin-top: 15px;

                    .upAnsBox {
                        width: 70px;
                        height: 70px;
                        margin-right: 10px;
                        border-radius: 4px;
                        border: 1px solid #dcdfe6;
                        overflow: hidden;
                        position: relative;

                        .upaMore {
                            width: 70px;
                            height: 70px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            font-size: 12px;
                        }

                        .updel {
                            position: absolute;
                            top: 0px;
                            right: -40px;
                            width: 100px;
                            height: 20px;
                            transform: rotate(40deg);
                            background-color: red;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            cursor: pointer;

                            img {
                                width: 12px;
                                height: 12px;
                            }
                        }
                    }
                }
            }
        }

        .bot {
            margin-top: 20px;
            display: flex;
            justify-content: center;
        }
    }
}
</style>